import abi from "./abis/ERC20base.json";
import {
  getv,
  iso,
  nils,
  tofeth,
  tofpval,
  toeth,
  base64_to_json,
  blocktime_iso,
} from "@/utils/utils";
import { ethers } from "ethers";
import _ from "lodash";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "@/contracts/contracts.jsx";

const k = "erc20_base";
// const abi_methods_map = _.keyBy(abi, "name");

// Token address mapping - generated from contractAddress_list
const TOKEN_ADDRESSES = {
  DEZ: contractAddress_list.DEZ,
  WETH: contractAddress_list.WETH,
  LC: contractAddress_list.lc,
  BGC: contractAddress_list.BGC,
  SGC: contractAddress_list.sgc,
};

class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];
    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);
      if (nils(par)) continue;
      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;
      logrows.push(o);
    }
    return logrows;
  }

  async balanceOf(account, info = {}) {
    let r = await this.run("balanceOf", [account], info);
    return r;
  }
  async allowance(owner, spender, info = {}) {
    let tx = await this.run("allowance", [owner, spender], info);
    return tx;
  }
  async approve(spender, amount, info = {}) {
    let tx = await this.run("approve", [spender, amount], info);
    return tx;
  }
}

const get_contract_address = (tokenSymbol) => {
  if (tokenSymbol.startsWith("0x")) return tokenSymbol;
  const address = TOKEN_ADDRESSES[tokenSymbol.toUpperCase()];
  if (!address) {
    throw new Error(`Token address not found for symbol: ${tokenSymbol}`);
  }
  return address;
};

const get_contract = async (tokenSymbol, ext = {}) => {
  const contractAddress = get_contract_address(tokenSymbol);
  const runner = new Contract({
    contract_k: `erc20_${tokenSymbol.toLowerCase()}`,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

// Helper function to add new token addresses
const addTokenAddress = (symbol, address) => {
  TOKEN_ADDRESSES[symbol.toUpperCase()] = address;
};

// Helper function to get all supported tokens
const getSupportedTokens = () => {
  return Object.keys(TOKEN_ADDRESSES);
};

const ERC20base = {
  k,
  get_contract,
  get_contract_address,
  addTokenAddress,
  getSupportedTokens,
  TOKEN_ADDRESSES,
};

export default ERC20base;
